import StorageHelper from '../../../../helper.js';

const scope = 'SB/dashboard/posts';
import _ from 'lodash';

let addPost = (state, statePostsName, newPost) => {
    const idx = state[statePostsName].findIndex(existingPost => existingPost.id === newPost.id);

    //If the post is already in our list, update that post
    if (idx > -1) {
        //Use Object.assign so the reactivity gets triggered for the object
        state[statePostsName][idx] =  Object.assign(state[statePostsName][idx], newPost);
    } else {
        //Otherwise, create a new one
        state[statePostsName].push(newPost);
    }

    state[statePostsName] = _.sortBy(state[statePostsName], ['broadcastAt']);
};

const defaultState = {
    broadcastedPosts: [],
    filterAuthId: 0,
    filterCampaignId: null
};

const mod = {
    namespaced: true,
    state: {
        broadcastedPosts: [],
        filterAuthId: 0,
        filterCampaignId: null
    },
    actions: {
        addBroadcastedPost ({ commit }, newPost) {
            commit('addBroadcastedPost', newPost);
        },
        broadcastedPosts({ commit }, posts) {
            commit('broadcastedPosts', posts);
        },
        filterAuthId({ commit }, authId) {
            StorageHelper.setLocalStorageVar(commit, authId || null, 'filterAuthId', scope);
        },
        filterCampaignId({ commit }, campaignId) {
            StorageHelper.setLocalStorageVar(commit, campaignId || null, 'filterCampaignId', scope);
        },
        reset({ commit }) {
            StorageHelper.resetState(commit, defaultState, scope);
        }
    },
    getters: {
        broadcastedPosts (state) {
            return state.broadcastedPosts;
        },
        filterAuthId (state) {
            return state.filterAuthId;
        },
        filterCampaignId (state) {
            return state.filterCampaignId;
        }
    },
    mutations: {
        addBroadcastedPost: (state, newPost) => {
            addPost(state, 'broadcastedPosts', newPost);
        },
        broadcastedPosts: (state, broadcastedPosts) => {
            state.broadcastedPosts = broadcastedPosts;
        },
        filterAuthId: (state, authId) => {
            state.filterAuthId = authId;
        },
        filterCampaignId: (state, campaignId) => {
            state.filterCampaignId = campaignId;
        }
    }
};

export default mod;
